$(document).ready(function () {

  if($('.banner-slider .banner-box').length > 1){  
    $('.banner-slider').slick({
        dots: true,
        infinite: true,
        speed: 400,
        slidesToShow: 1,
        arrows: false,
        slidesToScroll: 1,
        adaptiveHeight: true
    });
  }


$('.heaing-slider').slick({
  slidesToShow:5,
  slidesToScroll: 1,
  arrows: false,
  dots: false,
  speed: 10000,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 0,
  cssEase: 'linear',
  variableWidth: true,
  pauseOnHover: false,
  pauseOnFocus: false,
  swipe: false,
  touchMove: false,
  draggable: false
});

// $('.center-slider').slick({
//     slidesToShow: 3,
//     slidesToScroll: 1,
//     centerMode: true,
//     centerPadding: '0px',
//     arrows: true,
//     dots: false,
//     infinite: true,
//    responsive: [
//         {
//             breakpoint: 1367,
//             settings: {
//                 slidesToShow: 2
//             }
//         },
//         {
//             breakpoint: 768,
//             settings: {
//                 slidesToShow: 2
//             }
//         }
//     ]
// });

$(document).ready(function () {
  $('.video-grid.center-slider').not('.slick-initialized').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: '0px',
      arrows: true,
      dots: false,
      infinite: true,
      responsive: [
          {
              breakpoint: 1366,
              settings: {
                  slidesToShow: 2,
                  centerMode: false
              }
          },
          {
              breakpoint: 750,
              settings: {
                  slidesToShow: 1,
                  centerMode: false
              }
          }
      ]
  });
});

$('.why-choose-slider .why-choose-list').slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
    {
      breakpoint: 1367,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});


$('.logo-list').slick({
  slidesToShow:1,
  slidesToScroll: 1,
  arrows: false,
  dots: false,
  speed: 9000,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 0,
  cssEase: 'linear',
  variableWidth: true,
  pauseOnHover: false,
  pauseOnFocus: false,
  swipe: false,
  touchMove: false,
  draggable: false,
      responsive: [
    {
      breakpoint: 1366,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        speed:3000,
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 3000,
      }
    }
  ]
});



$(window).on('scroll', function() {
    if ($(window).scrollTop() > 50) {
        $('.site-header').addClass('header-scrolled');
    } else {
        $('.site-header').removeClass('header-scrolled');
    }
});

 
  
});

